export const indicatorHelp = {
  trend: {
    label: 'QQQ / Trend',
    description:
      'Nasdaq-100 ETF price vs. its 20- and 50-day moving averages. Price above rising averages = uptrend; price below = trend under pressure.',
  },
  movingAverages: {
    label: 'Moving Averages',
    description:
      "Simple moving averages of QQQ's closing price over the trailing 20 and 50 sessions. Used to gauge short- and medium-term trend direction.",
  },
  atrDistance: {
    label: 'ATR distance from 50DMA',
    description:
      'How many Average True Range (14-day) units price is stretched from its 50-day average. Above ~2.5 ATR historically raises odds of mean reversion; below −2.5 ATR signals an oversold stretch.',
  },
  distributionDays: {
    label: 'Distribution days',
    description:
      "A distribution day = a decline of 0.2%+ on higher volume than the prior session, counted over a rolling 25-session window. Five or more in that window signals institutional selling pressure ('Defensive mode'). The window resets on a confirmed follow-through day.",
  },
  followThrough: {
    label: 'FTD / Rally',
    description:
      "A Follow-Through Day confirms a new rally attempt: on or after day 4 of an attempted rally, a gain of 1.7%+ on higher volume than the prior session. Confirms the shift from correction to uptrend — until price undercuts the FTD day's low without a new confirmed FTD, which invalidates it.",
  },
  stocksAbove50Day: {
    label: '% above 50DMA',
    description:
      'Share of a broad stock universe trading above their own 50-day moving average. A rising %, especially above 60-70%, reflects broad participation; a falling % below 30-40% signals narrowing leadership even if the index itself looks fine.',
  },
  advanceDecline: {
    label: 'A/D line',
    description:
      'Cumulative running total of (advancing stocks − declining stocks) each session. Rising alongside the index confirms broad participation; a flat or falling A/D line while price makes new highs is a classic bearish divergence.',
  },
  vix: {
    label: 'VIX',
    description:
      "CBOE Volatility Index — the market's expected 30-day S&P 500 volatility, derived from options prices. Below ~15 = calm/complacent, 15-25 = normal, above 25 = elevated fear, above 35 = crisis-level stress.",
  },
  newHighs: {
    label: 'New highs',
    description:
      'Count of stocks in the universe hitting a fresh 52-week high (or low) that session. Expanding new highs confirm strength; a rising count of new lows even while the index is flat or up flags deteriorating breadth beneath the surface.',
  },
  newLows: {
    label: 'New lows',
    description:
      'Count of stocks in the universe hitting a fresh 52-week high (or low) that session. Expanding new highs confirm strength; a rising count of new lows even while the index is flat or up flags deteriorating breadth beneath the surface.',
  },
  putCall: {
    label: 'Put/call ratio',
    description:
      'CBOE total put/call ratio — puts traded divided by calls traded, market-wide. Above ~1.0 signals heavy hedging/bearish positioning (often a contrarian bullish extreme); below ~0.7 signals complacency/heavy call buying (often a contrarian caution signal).',
  },
  sectorRotation: {
    label: 'Sector rotation · 20d vs QQQ',
    description:
      '20-day relative performance of the 11 S&P sector ETFs vs. QQQ. Leadership rotating into defensive sectors (utilities, staples, healthcare) over cyclicals/tech often flags a risk-off shift beneath the index level.',
  },
  nfciCredit: {
    label: 'NFCI Credit Subindex',
    description:
      "Chicago Fed's weekly measure of credit market tightness, standardized to average 0. Positive = tighter than historical average (harder/costlier to borrow); negative = looser than average. Tightening credit has historically preceded broader market stress.",
  },
  nfci: {
    label: 'Headline NFCI',
    description:
      "Chicago Fed's broader financial conditions index, blending risk, credit, and leverage measures across money, debt, and equity markets. Positive = tighter than average, negative = looser. Sharp upward moves (it jumped from −0.6 to +1.3 in two weeks during March 2020) are a fast-moving stress signal.",
  },
  hygLqd: {
    label: 'HYG/LQD ratio',
    description:
      'Ratio of high-yield corporate bond ETF (HYG) to investment-grade bond ETF (LQD) price. Rising = high-yield outperforming = credit risk appetite improving (risk-on); falling = high-yield underperforming = spreads widening = credit stress building. Tends to move faster than NFCI and often leads equity weakness.',
  },
} as const;

export type IndicatorHelpKey = keyof typeof indicatorHelp;
